import styled from 'styled-components';
import {
  Box,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

export const DashboardContainer = styled(Box)`
  padding: 24px;
  background: #f5f7fb;
  min-height: 100vh;
`;

export const DashboardHeader = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:24px;
`;

export const DashboardTitle = styled(Typography)`
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937;
`;

export const SectionTitle = styled(Typography)`
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #374151;
  margin-bottom: 16px !important;
`;

export const FiltersContainer = styled(Paper)`
  padding: 16px;
  margin-bottom: 24px;
  border-radius: 12px !important;
`;

export const KPIContainer = styled(Grid)`
  margin-bottom: 24px !important;
`;

export const CardContainer = styled(Paper)`
  padding: 20px;
  border-radius: 12px !important;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
`;

export const CardTitle = styled(Typography)`
  font-size: 14px !important;
  color: #6b7280;
  font-weight: 500 !important;
`;

export const CardValue = styled(Typography)`
  font-size: 30px !important;
  font-weight: bold !important;
  color: #111827;
  margin-top: 10px !important;
`;

export const ChartContainer = styled(Paper)`
  padding: 20px;
  border-radius: 12px !important;
  height: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
`;

export const HalfChartContainer = styled(Paper)`
  padding: 20px;
  border-radius: 12px !important;
  height: 380px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
`;

export const TableContainer = styled(Paper)`
  padding: 20px;
  border-radius: 12px !important;
  margin-top: 24px;
`;

export const EmptyState = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #9ca3af;
  font-size: 18px;
`;

export const Spacer = styled(Box)`
  height: 24px;
`;

export const KPISectionTitle = styled(Typography)`
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #4b5563;
  margin-bottom: 12px !important;
`;

export const KPIGrid = styled(Grid)`
  margin-bottom: 24px !important;
`;

export const PeriodTabs = styled(Tabs)`
  margin-bottom: 24px;
`;

export const PeriodTab = styled(Tab)`
  text-transform: none !important;
  font-weight: 600 !important;
`;

export const KPIHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const KPIIconCircle = styled.div<{ color: string }>`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: white;
    font-size: 28px;
  }
`;

export const KPISubTitle = styled.div`
  font-size: 13px;
  color: #7c8aa5;
  margin-top: 8px;
`;

export const KPIValue = styled.div`
  font-size: 34px;
  font-weight: 700;
  color: #1f2937;
`;

export const ColoredCard = styled(CardContainer)<{
  border: string;
}>`
  border-top: 5px solid ${({ border }) => border};
  transition: all .25s ease;

  &:hover{
    transform: translateY(-5px);
    box-shadow:0 15px 35px rgba(0,0,0,.12);
  }
`;